module.exports = __webpack_public_path__ + "img/38.f1553662.jpg";